export enum routinesTypes {
  LOAD_ALL_ROUTINES_REQUEST = 'LOAD_ALL_ROUTINES_REQUEST',
  LOAD_ALL_ROUTINES_RESPONSE = 'LOAD_ALL_ROUTINES_RESPONSE',
  HANDLE_DELETE_ROUTINE_MODAL = 'HANDLE_DELETE_ROUTINE_MODAL',
  DELETE_ROUTINE_REQUEST = 'DELETE_ROUTINE_REQUEST',
  DELETE_ROUTINE_RESPONSE = 'DELETE_ROUTINE_RESPONSE',
  CLEAR_DELETE_ROUTINE_STATUS = 'CLEAR_DELETE_ROUTINE_STATUS',
  ACTIVATE_PAUSE_ROUTINE_REQUEST = 'ACTIVATE_PAUSE_ROUTINE_REQUEST',
  ACTIVATE_PAUSE_ROUTINE_RESPONSE = 'ACTIVATE_PAUSE_ROUTINE_RESPONSE',
  CLEAR_ERROR_STATUS = 'CLEAR_ERROR_STATUS',
}
export interface RoutinesState {
  loading: boolean,
  error: boolean,
  errorMessage: string,
  list: Array<any>,
  delete: {
    show: boolean,
    status: string,
    error: string,
  },
}
